import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'antd';
import { Menu } from './styles';
import createSubMenu from './sub-menu.js';
import MenuTitle from './menu-title';

const createChildren = (children) => {
  if (!children) {
    return null;
  }

  return (
    <React.Fragment>
      {children}
      <Divider style={{ margin: 0 }} />
    </React.Fragment>
  );
};

const SideBar = ({
  theme,
  mode,
  dataSource,
  children,
  onClick,
  onSelect,
  components,
  ...props
}) => (
  <Menu
    theme={theme}
    mode={mode}
    {...props}
    onClick={op => onClick({ ...op, entry: op.item.props.entry })}
    onSelect={op => onSelect({ ...op, entry: op.item.props.entry })}
  >
    {createChildren(children)}
    {createSubMenu({ dataSource, components })}
  </Menu>
);

SideBar.displayName = 'SideBar';

SideBar.propTypes = {
  ...Menu.propTypes,
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  theme: PropTypes.oneOf(['dark', 'light']),
  mode: PropTypes.oneOf(['vertical', 'inline']),
  children: PropTypes.node,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  components: PropTypes.object,
};

SideBar.defaultProps = {
  ...Menu.defaultProps,
  theme: 'light',
  mode: 'inline',
  children: null,
  onClick: () => null,
  onSelect: () => null,
  components: {
    MenuItem: ({ children }) => children,
  },
};

export default SideBar;
